module.exports = __webpack_public_path__ + "static/media/plane-fly.1cf1859c.gif";